import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const HELP_CENTER_FORM_REQUEST_CLIENT_ID: ClientId = client(
	'help-center-form-content-renderer',
);
